import { FeatureFlags } from '../../../common';
import { ISideMenuItem } from './interfaces.SideMenu';
import { TFunction } from 'i18next';

export const getSideMenuItems = (
    t: TFunction,
    featureFlags: Record<string, boolean | undefined>
): Array<ISideMenuItem> => {
    const isReportsFeatureFlagOn = featureFlags[FeatureFlags.REPORTS] ?? false;
    return [
        {
            key: 'dashboard',
            tooltipText: t('sideMenu.dashboard'),
            iconName: 'HomeIcon',
            path: 'dashboard',
        },
        {
            key: 'candidates',
            tooltipText: t('sideMenu.candidates'),
            iconName: 'CandidatesIcon',
            path: 'jobApplications',
        },
        {
            key: 'jobs',
            tooltipText: t('sideMenu.jobs'),
            iconName: 'JobsIcon',
            path: 'jobs',
        },
        {
            key: 'reports',
            tooltipText: t('sideMenu.reports'),
            iconName: 'ReportsIcon',
            path: 'reports',
            hide: !isReportsFeatureFlagOn,
        },
        {
            key: 'savedForLater',
            tooltipText: t('sideMenu.savedForLater'),
            iconName: 'SavedIcon',
            path: 'savedForLater',
        },
        {
            key: 'settings',
            tooltipText: t('sideMenu.settings'),
            iconName: 'SettingsOutlinedIcon',
            path: 'settings',
        },
    ];
};
